if (!customElements.get("careers-jobs")) {
  class CareersJobs extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll(".m-careers-jobs__card"));
      this.filters = Array.from(this.querySelectorAll(".m-careers-jobs__filter"));
      this.emptyMessage = this.querySelector(".m-careers-jobs__empty");
      this.pagination = this.querySelector(".m-careers-jobs__pagination");
      this.perPageDesktop = parseInt(this.dataset.perPageDesktop, 10) || 6;
      this.perPageMobile = parseInt(this.dataset.perPageMobile, 10) || 4;
      this.nextLabel = this.dataset.nextLabel || "Siguiente";
      this.mql = window.matchMedia("(max-width: 767px)");
      this.activeFilter = "all";
      this.page = 1;

      this.onFilterClick = this.onFilterClick.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.filters.forEach((btn) => btn.addEventListener("click", this.onFilterClick));
      this.mql.addEventListener("change", this.onMediaChange);
      document.addEventListener("shopify:block:select", this.onBlockSelect);

      this.render();
    }

    disconnectedCallback() {
      this.filters.forEach((btn) => btn.removeEventListener("click", this.onFilterClick));
      this.mql.removeEventListener("change", this.onMediaChange);
      document.removeEventListener("shopify:block:select", this.onBlockSelect);
    }

    get perPage() {
      return this.mql.matches ? this.perPageMobile : this.perPageDesktop;
    }

    // En el editor del tema, al seleccionar un puesto se muestra la pagina donde esta.
    onBlockSelect(event) {
      const index = this.cards.indexOf(event.target);
      if (index === -1) return;
      this.activeFilter = "all";
      this.filters.forEach((btn) => {
        const active = btn.dataset.filter === "all";
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-selected", active ? "true" : "false");
      });
      this.page = Math.floor(index / this.perPage) + 1;
      this.render();
    }

    onFilterClick(event) {
      this.activeFilter = event.currentTarget.dataset.filter;
      this.page = 1;
      this.filters.forEach((btn) => {
        const active = btn === event.currentTarget;
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-selected", active ? "true" : "false");
      });
      this.render();
    }

    onMediaChange() {
      this.page = 1;
      this.render();
    }

    goToPage(page) {
      this.page = page;
      this.render();
      const top = this.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
    }

    render() {
      const matching = this.cards.filter(
        (card) => this.activeFilter === "all" || card.dataset.category === this.activeFilter
      );

      const perPage = this.perPage;
      const totalPages = Math.max(Math.ceil(matching.length / perPage), 1);
      if (this.page > totalPages) this.page = totalPages;

      const start = (this.page - 1) * perPage;
      const visible = new Set(matching.slice(start, start + perPage));

      this.cards.forEach((card) => {
        card.hidden = !visible.has(card);
      });

      if (this.emptyMessage) this.emptyMessage.hidden = matching.length > 0;

      this.renderPagination(totalPages);
    }

    renderPagination(totalPages) {
      if (!this.pagination) return;
      this.pagination.innerHTML = "";
      if (totalPages <= 1) {
        this.pagination.hidden = true;
        return;
      }
      this.pagination.hidden = false;

      for (let i = 1; i <= totalPages; i++) {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "m-careers-jobs__page" + (i === this.page ? " is-active" : "");
        btn.textContent = i;
        btn.setAttribute("aria-label", "Página " + i);
        if (i === this.page) btn.setAttribute("aria-current", "page");
        btn.addEventListener("click", () => this.goToPage(i));
        this.pagination.appendChild(btn);
      }

      if (this.page < totalPages) {
        const next = document.createElement("button");
        next.type = "button";
        next.className = "m-careers-jobs__next";
        next.innerHTML =
          "<span>" +
          this.nextLabel +
          '</span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="M13 6l6 6-6 6"></path></svg>';
        next.addEventListener("click", () => this.goToPage(this.page + 1));
        this.pagination.appendChild(next);
      }
    }
  }

  customElements.define("careers-jobs", CareersJobs);
}
